// US state → climate zone mapping. Zones are drawn from Köppen-simplified EV
// telemetry buckets — this is the exact resolution EVIQ needs to model heat +
// cold effects on lithium-ion aging. State list covers CONUS + AK/HI.

export const CLIMATE_ZONES = {
  "hot-desert":   { label: "Hot desert",     summer_high_f: 108, winter_low_f: 45, hue: "#FFB020" },
  "hot-humid":    { label: "Hot humid",      summer_high_f: 96,  winter_low_f: 42, hue: "#FF7A5C" },
  "temperate":    { label: "Temperate",      summer_high_f: 88,  winter_low_f: 26, hue: "#39FF14" },
  "mild-coastal": { label: "Mild coastal",   summer_high_f: 78,  winter_low_f: 42, hue: "#00E5FF" },
  "cold-north":   { label: "Cold north",     summer_high_f: 84,  winter_low_f: 8,  hue: "#67E8F9" },
  "high-elevation": { label: "High-elevation", summer_high_f: 86, winter_low_f: 14, hue: "#C7D2FE" },
};

// State code → zone
export const US_STATES = [
  { code: "AL", name: "Alabama",        zone: "hot-humid" },
  { code: "AK", name: "Alaska",         zone: "cold-north" },
  { code: "AZ", name: "Arizona",        zone: "hot-desert" },
  { code: "AR", name: "Arkansas",       zone: "hot-humid" },
  { code: "CA", name: "California",     zone: "mild-coastal" },
  { code: "CO", name: "Colorado",       zone: "high-elevation" },
  { code: "CT", name: "Connecticut",    zone: "temperate" },
  { code: "DE", name: "Delaware",       zone: "temperate" },
  { code: "FL", name: "Florida",        zone: "hot-humid" },
  { code: "GA", name: "Georgia",        zone: "hot-humid" },
  { code: "HI", name: "Hawaii",         zone: "mild-coastal" },
  { code: "ID", name: "Idaho",          zone: "high-elevation" },
  { code: "IL", name: "Illinois",       zone: "cold-north" },
  { code: "IN", name: "Indiana",        zone: "cold-north" },
  { code: "IA", name: "Iowa",           zone: "cold-north" },
  { code: "KS", name: "Kansas",         zone: "temperate" },
  { code: "KY", name: "Kentucky",       zone: "temperate" },
  { code: "LA", name: "Louisiana",      zone: "hot-humid" },
  { code: "ME", name: "Maine",          zone: "cold-north" },
  { code: "MD", name: "Maryland",       zone: "temperate" },
  { code: "MA", name: "Massachusetts",  zone: "cold-north" },
  { code: "MI", name: "Michigan",       zone: "cold-north" },
  { code: "MN", name: "Minnesota",      zone: "cold-north" },
  { code: "MS", name: "Mississippi",    zone: "hot-humid" },
  { code: "MO", name: "Missouri",       zone: "temperate" },
  { code: "MT", name: "Montana",        zone: "cold-north" },
  { code: "NE", name: "Nebraska",       zone: "temperate" },
  { code: "NV", name: "Nevada",         zone: "hot-desert" },
  { code: "NH", name: "New Hampshire",  zone: "cold-north" },
  { code: "NJ", name: "New Jersey",     zone: "temperate" },
  { code: "NM", name: "New Mexico",     zone: "hot-desert" },
  { code: "NY", name: "New York",       zone: "cold-north" },
  { code: "NC", name: "North Carolina", zone: "temperate" },
  { code: "ND", name: "North Dakota",   zone: "cold-north" },
  { code: "OH", name: "Ohio",           zone: "cold-north" },
  { code: "OK", name: "Oklahoma",       zone: "temperate" },
  { code: "OR", name: "Oregon",         zone: "mild-coastal" },
  { code: "PA", name: "Pennsylvania",   zone: "cold-north" },
  { code: "RI", name: "Rhode Island",   zone: "temperate" },
  { code: "SC", name: "South Carolina", zone: "hot-humid" },
  { code: "SD", name: "South Dakota",   zone: "cold-north" },
  { code: "TN", name: "Tennessee",      zone: "temperate" },
  { code: "TX", name: "Texas",          zone: "hot-humid" },
  { code: "UT", name: "Utah",           zone: "high-elevation" },
  { code: "VT", name: "Vermont",        zone: "cold-north" },
  { code: "VA", name: "Virginia",       zone: "temperate" },
  { code: "WA", name: "Washington",     zone: "mild-coastal" },
  { code: "WV", name: "West Virginia",  zone: "temperate" },
  { code: "WI", name: "Wisconsin",      zone: "cold-north" },
  { code: "WY", name: "Wyoming",        zone: "high-elevation" },
];

export const getClimate = (stateCode) => {
  const st = US_STATES.find((s) => s.code === stateCode) || US_STATES[0];
  const z = CLIMATE_ZONES[st.zone];
  return {
    state: st.code,
    state_name: st.name,
    zone: st.zone,
    summer_high_f: z.summer_high_f,
    winter_low_f: z.winter_low_f,
    label: `${z.label} · ${st.name}`,
    hue: z.hue,
  };
};

// Season detection helper — used to color-code the "current season" pill.
export const currentSeasonLabel = () => {
  const m = new Date().getMonth() + 1;
  if (m >= 12 || m <= 2) return "Winter";
  if (m <= 5) return "Spring";
  if (m <= 8) return "Summer";
  return "Fall";
};
